
import { textDiv, getColor, imageUrl, buttonString, textString } from './texts.js';
import Logger from './logger.js';
import events from './event.js';
import _ from './translate.js';
import Table from './table.js';
import products from './products.js';
import Storage from './storage.js';
import HelpPopup from './HelpPopup.js';


class UploadStep {
    dropzoneBlocker = null;
    customizerContentDiv = null;
    cropWrapper = null;
    wrapperDiv = null;
    table = null;
    selectPaperDiv = null;
    uploadButton = null;

    constructor(customizerContentDiv, cropWrapper = null) {
        this.customizerContentDiv = customizerContentDiv;
        this.cropWrapper = cropWrapper;
        if (!this.customizerContentDiv) {
            Logger.error('Upload step failed to load.');
            return;
        }
        this.init();
    }


    async init() {
        if (this.wrapperDiv) {
            // If already initialized, just show the wrapper, handled by CSS
            return;
        }

        this.wrapperDiv = document.createElement('div');
        this.wrapperDiv.classList.add('mscp-upload-wrapper');
        // this.wrapperDiv.style.position = 'relative';

        // Skapa wrapper för pappersvalstabell
        this.selectPaperDiv = document.createElement('div');
        this.selectPaperDiv.classList.add('mscp-upload-paper-list');
        this.wrapperDiv.appendChild(this.selectPaperDiv);

        // Skapa och rendera pappersvalstabell (egen storage-key)
        const papers = await products.getPapers();
        this.table = new Table({
            wrapperDiv: this.selectPaperDiv,
            terms: papers,
            type: 'uploadPaper', // unik storage-key
            postCreateTitleCallback: async (term) => {
                // Visa ev. pris
                return null;
            },
            selectCallback: (el, value, oldValue) => {
                this.updateUploadButtonState();
                if (this.helpPopup) this.helpPopup.hide();
                events.trigger('setPaperSelection', value); // Notify other modules of paper selection
            }
        });

        events.add('reInitUpload', () => {
            this.table.deselectAll();
            Storage.save('uploadPaper', '');
            this.updateUploadButtonState();
        });

        // Hitta dropzoneDiv (från upload.js) om den finns
        this.dropzoneDiv = document.querySelector('.mscp-dropzone');

        // 5. Skapa blocker/overlay för dropzone
        if (this.dropzoneDiv && !this.dropzoneDiv.querySelector('.mscp-dropzone-blocker')) {
            this.dropzoneBlocker = document.createElement('div');
            this.dropzoneBlocker.classList.add('mscp-dropzone-blocker');
            this.dropzoneBlocker.style.display = 'none';
            this.dropzoneBlocker.style.position = 'absolute';
            this.dropzoneBlocker.style.top = '0';
            this.dropzoneBlocker.style.left = '0';
            this.dropzoneBlocker.style.width = '100%';
            this.dropzoneBlocker.style.height = '100%';
            this.dropzoneBlocker.style.zIndex = '20';
            this.dropzoneBlocker.style.cursor = 'not-allowed';
            this.dropzoneDiv.appendChild(this.dropzoneBlocker);

            // Klick på overlayn togglar disabled-popup
            this.dropzoneBlocker.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (this.helpPopup) this.helpPopup.toggle(this.uploadButton);
            });
        }

        this.createUploadButton();
        this.customizerContentDiv.appendChild(this.wrapperDiv);

        // 5. Visa texten under tabellen
        textDiv(this.wrapperDiv, 'upload_general_text');


        // 6. Info-knapp (nu som syskon till upload-knappen, ej child till wrapper)
        const infoButton = document.createElement('div');
        infoButton.classList.add('mscp-upload-info-button', 'mscp-button');
        infoButton.style.border = 'none';
        infoButton.style.background = 'none';
        infoButton.addEventListener('click', () => {
            events.trigger('openAdditionalInfoPopup', {
                text_prop_name: 'upload_info_text'
            });
        });

        const infoButtonLabel = document.createElement('span');
        infoButtonLabel.classList.add('mscp-upload-info-button-label', 'mscp-button-label');
        infoButtonLabel.innerHTML = buttonString('upload_navigation_label');
        infoButton.appendChild(infoButtonLabel);

        const infoButtonIcon = document.createElement('span');
        infoButtonIcon.classList.add('mscp-upload-info-button-icon', 'icon-wrapper');
        infoButtonIcon.innerHTML = mindstore_object?.icon?.info || '';
        infoButton.appendChild(infoButtonIcon);

        this.wrapperDiv.appendChild(infoButton);

        // Initiera knappens state
        this.updateUploadButtonState();

        // Add a flex spacer before the logo to push it to the bottom if space allows
        const spacer = document.createElement('div');
        spacer.classList.add('mscp-upload-content-spacer');
        this.wrapperDiv.appendChild(spacer);

        // Footer logo (always last in wrapper, styled in SCSS)
        const logoUrl = imageUrl('upload_footer_logo');
        if (logoUrl) {
            const logoFooter = document.createElement('div');
            logoFooter.classList.add('mscp-upload-footer-logo');
            const logoImg = document.createElement('img');
            logoImg.src = logoUrl;
            logoImg.alt = 'Footer Logo';
            logoFooter.appendChild(logoImg);
            this.wrapperDiv.appendChild(logoFooter);
        }

    }

    createUploadButton() {
        if (this.uploadButton) return;
        this.uploadButton = document.createElement('div');
        this.uploadButton.classList.add('mscp-upload-btn', 'mscp-button', 'mscp-centered-button');
        // Inner label span
        const uploadButtonLabel = document.createElement('span');
        uploadButtonLabel.classList.add('mscp-upload-btn-label', 'mscp-button-label');
        uploadButtonLabel.innerHTML = buttonString('upload_button_label', 'Upload Image');
        // Icon (if any)
        let uploadIcon = imageUrl('upload_button_image', '');
        let uploadButtonIcon = null;
        if (uploadIcon) {
            uploadButtonIcon = document.createElement('span');
            uploadButtonIcon.classList.add('mscp-upload-btn-icon', 'info-icon');
            uploadButtonIcon.innerHTML = '<img src="' + uploadIcon + '" alt="Upload Icon" />';
        }
        // Build the button
        this.uploadButton.appendChild(uploadButtonLabel);
        if (uploadButtonIcon) this.uploadButton.appendChild(uploadButtonIcon);
        this.uploadButton.disabled = true;

        // Skapa återanvändbar HelpPopup för disabled helptext
        this.helpPopup = new HelpPopup({
            parentElement: this.cropWrapper || this.customizerContentDiv,
            textKey: 'upload_disabled_helptext',
            defaultText: 'Please select a paper type to enable uploading.',
        });

        this.uploadButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!this.uploadButton.disabled) {
                events.trigger('showFileUpload', true);
            } else {
                if (this.helpPopup) this.helpPopup.toggle(this.uploadButton);
            }
        });

        // Lägg till upload-knappen i cropWrapper om den finns, annars fallback
        if (this.cropWrapper) {
            this.cropWrapper.appendChild(this.uploadButton);
        } else {
            this.customizerContentDiv.appendChild(this.uploadButton);
        }
    }

    updateUploadButtonState() {
        // Kolla om ett papper är valt i uploadPaper
        const selected = Storage.get('uploadPaper');
        const activeColor = getColor('upload_button_color_active', '#000');
        const passiveColor = getColor('upload_button_color_passive', '#aaa');
        if (!this.uploadButton) {
            this.createUploadButton();
        }
        if (selected) {
            this.uploadButton.disabled = false;
            this.uploadButton.style.backgroundColor = activeColor;
            if (this.dropzoneBlocker) this.dropzoneBlocker.style.display = 'none';
        } else {
            this.uploadButton.disabled = true;
            this.uploadButton.style.backgroundColor = passiveColor;
            if (this.dropzoneBlocker) this.dropzoneBlocker.style.display = 'block';
        }
    }



}
export default UploadStep;